import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { FacturaPoseedorControllerService } from 'api-rest';
import { DocumentService } from '../../../services/document.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import Swal from 'sweetalert2';
import { HoldersInvoiceNewDocumentDialogComponent } from '../holders-invoice-document-dialog/holders-invoice-document-dialog.component';
import { HoldersInvoiceRejectDialogComponent } from '../holders-invoice-reject-dialog/holders-invoice-reject-dialog.component';
import { HoldersCvfInvoiceNewDocumentDialogComponent } from '../holders-cvf-invoice-new-document-dialog/holders-cvf-invoice-new-document-dialog.component';
import { HoldersCvfInvoiceRejectDialogComponent } from '../holders-cvf-invoice-reject-dialog/holders-cvf-invoice-reject-dialog.component';

@Component({
    selector: 'lib-holders-cvf-invoices-dialog',
    templateUrl: './holders-cvf-invoices-dialog.component.html',
    styleUrls: ['./holders-cvf-invoices-dialog.component.scss'],
})
export class HoldersCvfInvoicesDialogComponent implements OnInit {

    modelForm!: FormGroup;
    documento: File | undefined;
    mustSeach: boolean = false;


    constructor(
        @Inject('environment') private environment: any,
        private formBuilder: FormBuilder,
        private router: Router,
        public dialog: MatDialog,
        public spinnerSrv: SpinnerService,
        private snackBarSrv: SnackbarService,
        private dialogRef: MatDialogRef<HoldersCvfInvoicesDialogComponent>,
        private facturaPoseedorService: FacturaPoseedorControllerService,
        private downloadService: DownloadService,
        private documentService: DocumentService,
        @Inject('EmpusaAuthenticationService')
        private authService: EmpusaAuthenticationService,
        @Inject(MAT_DIALOG_DATA) public factura: any,
    ) {

        this.inicializarForm();
    }

    ngOnInit() {
        this.cargaInicial();
    }
    close(result?: any) {
        this.dialogRef.close(result);
    }

    inicializarForm() {
        this.modelForm = this.formBuilder.group({
            id: [{ value: this.factura?.id, disabled: true }],
            gestor: [{ value: `${this.factura?.gestoresResiduos?.nima} - ${this.factura?.gestoresResiduos?.razonSocial}`, disabled: true }],
            estado: [{ value: this.factura?.estado?.descripcion, disabled: true }],
            numeroPrefactura: [{ value: this.factura?.fechaAutofactura ? this.factura?.id : '', disabled: true }],
            fechaPrefactura: [{ value: this.factura?.fechaAutofactura, disabled: true }],
            numeroFactura: [{ value: this.factura?.numeroFactura, disabled: true }],
            fechaFactura: [{ value: this.factura?.fechaFactura, disabled: true }],
            // registrada: [{ value: this.factura?.registrada, disabled: true }],
        });

    }

    cargaInicial() {
        this.modelForm.disable();
    }

    closeDialog(): void {
        this.dialogRef.close(this.mustSeach);
    }

    showClearButton(formName: string): boolean {
        return this.modelForm.get(formName)?.value !== null;
    }

    clearSelection(event: Event, formName: string) {
        event.stopPropagation();
        this.modelForm.get(formName)?.setValue(null);
    }

    controlHasError(controlName: string, errorName: string) {
        return (
            this.modelForm.controls[controlName].hasError(errorName) &&
            this.modelForm.controls[controlName].touched
        );
    }

    attachAdjunto(archivo: File | null): void {
        if (archivo) {
            if (archivo.size === 0) {
                this.snackBarSrv.showSnackBar(
                    'No se puede subir un fichero vacío',
                    'error'
                );
            } else if (archivo.size > 12 * 1024 * 1024) { // 5 MB
                this.snackBarSrv.showSnackBar(
                    'El fichero supera el tamaño máximo permitido de 12 MB',
                    'error'
                );
            } else {
                this.documento = archivo;
            }
        }
    }

    descargar(documento: any) {
        this.spinnerSrv.loadingShow();
        this.documentService.descargarDocumento(documento.id).subscribe({
            next: (response) => {
                this.spinnerSrv.loadingHide();
                this.snackBarSrv.showSnackBar(
                    'Se ha descargado el documento correctamente',
                    'success'
                );
                this.downloadService.downloadBlob(response, documento.nombre);
            },
            error: () => {
                this.spinnerSrv.loadingHide();
            },
        });
    }

    descargarDetallePrefacturacion() {
        this.facturaPoseedorService.prefacturaDetalle(this.factura?.id, 'response')
            .subscribe((res: any) => {
                const filename = this.downloadService.getFileName(
                    res.headers,
                    'Prefacturación.xlsx'
                );
                this.downloadService.downloadBlob(res.body!, filename!);
            });
    }

    canAccessEditByRol(): boolean {
        return this.authService.can('poseedores-di-detalle', 'access-update');
    }

    canAccessAcceptInvoice() {
        const resultUpdateAccept = this.authService.can(
            'poseedores-facturas',
            'update-accept'
        );
        const estado2 = this.factura?.estado && this.factura?.estado.id === 2; //Facturada
        return resultUpdateAccept && estado2;
    }

    canRejectInvoice() {
        const resultReject = this.authService.can(
            'poseedores-facturas',
            'reject-factura'
        );
        const estado2 = this.factura?.estado && this.factura?.estado.id === 2; //Facturada
        return resultReject && estado2;
    }

    canAccessDonwloadInvoice() {
        const resultDownloadFactura = this.authService.can(
            'poseedores-facturas',
            'download-factura'
        );

        const estado2 = this.factura?.estado && this.factura?.estado.id === 2; //Facturada
        const estado3 = this.factura?.estado && this.factura?.estado.id === 3; //Aceptada

        return (this.canViewResource('PO-GESTOR') || this.canViewResource('PO-ENV-GEST')) && (estado2 || estado3);
    }

    canAccessDonwloadSelfInvoice() {
        const resultDownloadAutofactura = this.authService.can(
            'poseedores-facturas',
            'download-autofactura'
        );
        return (this.canViewResource('PO-GESTOR') || this.canViewResource('PO-ENV-GEST'));
    }

    canAccessUpInvoice() {
        const resultUpFactura = this.authService.can(
            'poseedores-facturas',
            'update'
        );
        const estado1 = this.factura?.estado && this.factura?.estado.id === 1; //Pdte Factura
        const estado4 = this.factura?.estado && this.factura?.estado.id === 4; //Rechazada
        return (this.canViewResource('PO-GESTOR') || this.canViewResource('PO-ENV-GEST')) && (estado1 || estado4);
    }

    canAccessRegistrate() {
        const resultRegistrate = this.authService.can(
            'poseedores-facturas',
            'registrar'
        );
        const estado3 = this.factura?.estado && this.factura?.estado.id === 3; //Aceptada
        return resultRegistrate && estado3 && !this.factura?.registrada;
    }

    openModalUploadInvoice(): void {
        const dialogRef = this.dialog.open(
            HoldersCvfInvoiceNewDocumentDialogComponent,
            {
                width: '650px',
                maxWidth: '95%',
                maxHeight: '95vh',
                data: {
                    itemOpen: this.factura,
                },
                disableClose: true,
            }
        );
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                //refrescar
                this.spinnerSrv.loadingShow();
                this.actualizarRegistro();
            }
        });
    }

    actualizarRegistro() {
        this.facturaPoseedorService.getById4(this.factura?.id)
            .subscribe({
                next: (data: any) => {
                    this.spinnerSrv.loadingHide();
                    if (data) {
                        this.factura = data;
                        this.inicializarForm();
                        this.mustSeach = true;
                    }
                },
                error: (error: any) => {
                    this.spinnerSrv.loadingHide();
                },
            });
    }

    aceptarFactura() {
        this.confirmacionCambioEstado(this.factura?.id, 3);
    }

    confirmacionCambioEstado(id?: any, estadoId?: any): void {
        Swal.fire({
            text: `¿Desea cambiar el estado del registro por Aceptada por Envalora?`,
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sí',
            denyButtonText: 'No',
            allowOutsideClick: false,
        }).then((result: any) => {
            if (result.isConfirmed) {
                this.actualizarEstado(id, estadoId);
            }
        });
    }

    actualizarEstado(id?: any, estadoId?: any) {
        if (id && estadoId) {
            this.spinnerSrv.loadingShow();
            this.facturaPoseedorService
                .actualizarEstado(id, estadoId)
                .subscribe({
                    next: () => {
                        this.spinnerSrv.loadingHide();
                        this.snackBarSrv.showSnackBar(
                            `El registro de factura se ha actualizado correctamente`,
                            'success'
                        );
                        this.actualizarRegistro();
                    },
                    error: (err: { message: any }) => {
                        this.spinnerSrv.loadingHide();
                    },
                });
        }
    }

    openModalMotivoRechazo() {
        const dialogRef = this.dialog.open(
            HoldersCvfInvoiceRejectDialogComponent,
            {
                width: '750px',
                maxWidth: '95%',
                maxHeight: '95vh',
                data: {
                    info: this.factura,
                },
                disableClose: true,
            }
        );
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.actualizarRegistro();
            }
        });
    }

    canViewRegistrada(): boolean {
        return this.authService.can('poseedores-facturas', 'view-registrada');
    }

    registrarFactura() {
        this.spinnerSrv.loadingShow();
        this.facturaPoseedorService.registrarFactura(this.factura?.id)
            .subscribe({
                next: (res: any) => {
                    this.spinnerSrv.loadingHide();
                    this.snackBarSrv.showSnackBar(
                        `La factura se ha registrado correctamente`,
                        'success'
                    );
                    this.actualizarRegistro();
                },
                error: (err: { message: any }) => {
                    this.spinnerSrv.loadingHide();
                },
            });
    }
    canViewResource(rol: string): boolean {
        return this.authService.hasCurrentUserRole(rol);
    }


}
